import { Inject, Injectable } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { APP_PRODUCT_ROUTE, EXPERIMENT_VARIATIONS, FeatureToggleEnum } from '~shared/constants';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OptimizelyService } from '~shared/services/optimizely.service';

@Injectable()
export class PDPNavigatorService {
  constructor(
    private readonly featureFlagService: ActiveFeaturesConfigcatService,
    private optimizelyService: OptimizelyService,
    @Inject(APP_BASE_HREF) private baseHref: string
  ) {}

  navigateToPDP(e: Event, productId: string, query: string = '', fromCarousel: boolean = false): Observable<boolean> {
    //NOSONAR
    return this.navigateToReactPDP(e, productId, query, fromCarousel);
  }

  navigateToReactPDP(e: Event, productId: string, query: string = '', fromCarousel: boolean): Observable<boolean> {
    //NOSONAR
    e.preventDefault();
    e.stopPropagation();

    const url = this.getPdpLink(productId, query);

    return this.optimizelyService.getExperimentVariant('opening_pdp_in_a_new_tab').pipe(
      switchMap((variant: string) => {
        if ((!variant || variant === EXPERIMENT_VARIATIONS.VARIANT_TWO) && fromCarousel) {
          window.open(url, '_blank', 'noopener,noreferrer');
        } else {
          window.location.href = url;
        }
        return of(true);
      })
    );
  }
  getPdpLink(productId: string, query: string = ''): string {
    return `/${this.baseHref.replace(new RegExp('/', 'g'), '')}/${APP_PRODUCT_ROUTE}/${productId}${
      query.length ? query : '' //NOSONAR
    }`;
  }
}
